import { RegWallPreview } from './RegWallPreview';

export * from './RegWallPreview';
export default RegWallPreview;
